// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosError } from 'axios';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { concatMap } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { updateOnlineCourseProgress } from '../../../apis/onlineCourse';
import { RootAction, actionCreatorsList } from '../../rootActionCreator';
const { updateOnlineCourseProgressActions } = actionCreatorsList;

const outputActions = {
  success: updateOnlineCourseProgressActions.success,
  failure: updateOnlineCourseProgressActions.failure
};

type RequestActionTypes = ActionType<
  typeof updateOnlineCourseProgressActions.request
>;
type OutputActionTypes = ActionType<typeof outputActions>;

const updateOnlineCourseProgressEpic = (
  action$: Observable<RootAction>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      // action filter
      getType(updateOnlineCourseProgressActions.request)
    ),
    concatMap((action: RequestActionTypes) => {
      // prepare api params
      const { id, progress, onSuccess } = action.payload;
      // send api promise
      return updateOnlineCourseProgress(id, progress)
        .then(response => {
          const { progress } = response.data;
          // handle success case here
          onSuccess();
          return updateOnlineCourseProgressActions.success({
            id,
            progress
          });
        })
        .catch((error: AxiosError) => {
          // handle error case here
          console.log(error)
          return updateOnlineCourseProgressActions.failure({ error });
        });
    })
  );
};

export { updateOnlineCourseProgressEpic as default};
